import React, { useEffect } from "react";
import Navbar from "./Component/Navbar";
import Footer from "./Component/Footer";
import BusinessAppSection from "./Component/Vendor/BusinessAppSection";
import BusinessOpportunity from "./Component/Vendor/BusinessOpportunity";
import FeaturesSection from "./Component/Vendor/FeaturesSection";
import Testimonial from "./Component/Vendor/Testimonial";
import ReadyToStart from "./Component/Vendor/ReadyToStart";
import FAQSection from "./Component/FAQSection";

import AOS from "aos";
import "aos/dist/aos.css"; // Import the AOS styles
// import VendorVideo from "./Component/Vendor/VendorVideo";

const VendorLandingPage = () => {
  const faqs = [
    {
      question: "Is Pixell an online platform?",
      answer:
        "Yes, Pixell is an online platform. You have to sign up on your mobile app and fill in the basic details about your business. Our verification team will reach out to you for physical verification of your business premises to verify the information that you have provided. ",
    },
    {
      question: "How does Pixell Work?",
      answer:
        "Once verified you will start receiving enquiries of work on your mobile application. You can accept or reject it as per your convenience.",
    },
    {
      question: "Who is responsible for the last mile delivery?",
      answer:
        "Of course, Pixell owns the responsibility for the project delivery. You will not be required to speak to any client and installation partners during the course of the assignment. Your go to resource will be the operations team at Pixell that will guide you through the details of the assignment in case of any confusion.",
    },
    {
      question: "Is my payment secure?",
      answer:
        "Yes, your payment is completely secure. You will be issued an advance before the commencement of the assignment. Remaining payments follow on a milestone basis. All payments are transferred digitally.",
    },
    {
      question:
        "Will the vendor be undertaking recce and installation assignment?",
      answer:
        "No, the vendor will not be required to undertake recce and installation assignments.These jobs will be executed by Pixell team. We believe that the vendor partner should only focus on their core competency. I.e manufacturing. ",
    },
    {
      question: "Is my data secure?",
      answer:
        "Yes, your data is absolutely safe. We believe that trust is paramount in a relationship. We do not own or sell your data. We also don't pass your data to third party applications without your permission. Your data rests in our database in a completely secure and encrypted form that leaves no scope of data pilferage.",
    },
  ];
  useEffect(() => {
    AOS.init({
      offset: 120,

      duration: 1000, // Set the duration of the animation
      easing: "ease-in-out", // Set the easing function
      once: false, // Animation will run only once
    });
  }, []);

  return (
    <div>
      <BusinessOpportunity />
      {/* <VendorVideo /> */}
      <BusinessAppSection />
      <FeaturesSection />
      <Testimonial />
      <ReadyToStart />
      <FAQSection faqs={faqs} />
    </div>
  );
};
export default VendorLandingPage;
